import { useUser } from '@/features/account/services/User/hooks'
import { useEffect } from 'react'
import { identifyUser } from '@/features/shared/analytics/users'

// updates the user's identity for analytics whenever user data is updated
export const useIdentifyUser = () => {
  const user = useUser()

  useEffect(() => {
    if (user) identifyUser(user)
  }, [user])
}
